export const SERVER_HOST_QR = 'https://dev.demo.lfs.rest/api/v4/'
export const DEFAULT_LANG = 'en'

